/**
 * Page-view counts for `page_views` trigger timing — same localStorage shape as
 * ometrics-ai v1 `cookieUtils` (`ometrics_page_view_${agentId}`).
 */

const EXPIRATION_MS = 30 * 24 * 60 * 60 * 1000

function storageKey(agentId) {
  return `ometrics_page_view_${agentId}`
}

/**
 * @param {string} agentId
 * @returns {number}
 */
export function getPageViewCountFromStorage(agentId) {
  if (!agentId || typeof Storage === 'undefined' || !localStorage) return 0
  try {
    const stored = localStorage.getItem(storageKey(agentId))
    if (!stored) return 0
    const data = JSON.parse(stored)
    const now = Date.now()
    if (data.timestamp && now - data.timestamp > EXPIRATION_MS) {
      localStorage.removeItem(storageKey(agentId))
      return 0
    }
    return typeof data.count === 'number' ? data.count : 0
  } catch {
    try {
      localStorage.removeItem(storageKey(agentId))
    } catch {
      // ignore
    }
    return 0
  }
}

/**
 * Increments persisted page views for this agent (once per widget mount path).
 *
 * @param {string} agentId
 * @returns {number} New count
 */
export function updatePageViewCount(agentId) {
  if (!agentId || typeof Storage === 'undefined' || !localStorage) return 0
  const now = Date.now()
  const key = storageKey(agentId)
  try {
    const stored = localStorage.getItem(key)
    let count = 1
    if (!stored) {
      localStorage.setItem(key, JSON.stringify({ count: 1, timestamp: now }))
      return 1
    }
    try {
      const data = JSON.parse(stored)
      if (data.timestamp && now - data.timestamp > EXPIRATION_MS) {
        count = 1
        localStorage.setItem(key, JSON.stringify({ count: 1, timestamp: now }))
      } else {
        count = (typeof data.count === 'number' ? data.count : 0) + 1
        localStorage.setItem(
          key,
          JSON.stringify({ count, timestamp: data.timestamp || now }),
        )
      }
    } catch {
      localStorage.setItem(key, JSON.stringify({ count: 1, timestamp: now }))
      count = 1
    }
    return count
  } catch {
    return 0
  }
}
